import React, { useEffect, useState } from "react";
import axios from "axios";
import useViewport from "components/UseViewport/UseViewport";
import { Row, Col, Card, Typography } from "antd";
import { ActiveMember } from "../../interfaces/activeMember";
import { StyledRow, StyledCol, StyledList, StyledItem, StyledText, StyledName, StyledImg } from "./style";
import CodeOfConduct from "./CodeOfConduct/CodeOfConduct";

const { Text, Title, Paragraph } = Typography;

interface Props {
  activeMemberId: number | undefined;
  closeTime: string;
}

const EventInfo: React.FC<Props> = ({ activeMemberId, closeTime }) => {
  const [activeMember, setActiveMember] = useState<ActiveMember>();

  const { width } = useViewport();
  const breakpoint = 992;
  const xsBreakpoint = 575;

  useEffect(() => {
    if (activeMember) return;
    activeMemberId
      ? axios.get<ActiveMember>(`/internal/active-members/${activeMemberId}/`).then(response => {
          setActiveMember(response.data);
        })
      : null;
  });

  return (
    <>
      <Card style={{ width: "80%" }}>
        <StyledRow>
          <StyledCol xs={24} md={24} lg={12}>
            <Title level={5}>Oppførsel</Title>
            <StyledList>
              <StyledItem>
                <StyledText>Mobilbruk er ikke tillatt under selve presentasjonen</StyledText>
              </StyledItem>
              <StyledItem>
                <StyledText>Ikke forlat rommet under presentasjonen</StyledText>
              </StyledItem>
              <StyledItem>
                <StyledText>Reservert-lapper skal ikke flyttes</StyledText>
              </StyledItem>
            </StyledList>
            <Paragraph style={{ marginTop: "1.3em" }}>Brudd på reglementet vil medføre prikk</Paragraph>
            <br />

            <CodeOfConduct closeTime={closeTime} />

            <br />
            <br />
          </StyledCol>

          <StyledCol
            xs={24}
            md={24}
            lg={12}
            style={
              width < breakpoint
                ? { borderTop: "1px solid rgba(10, 40, 63, 0.25)", paddingTop: "3%" }
                : { borderLeft: "1px solid rgba(10, 40, 63, 0.25)" }
            }
          >
            <>
              <Title level={5}>Spørsmål vedrørende dette arrangementet henvendes til: </Title>
              <br />
              {activeMember ? (
                <Row gutter={[20, 20]}>
                  <Col style={width < xsBreakpoint ? { textAlign: "center", width: "100%" } : {}}>
                    <StyledImg src={activeMember.profile_picture} alt="BL member profile picture" />
                  </Col>
                  <Col style={width < xsBreakpoint ? { textAlign: "center", width: "100%" } : {}}>
                    <StyledName>{activeMember.full_name}</StyledName>
                    <br />
                    <br />
                    <Text>
                      <a href={`mailto:${activeMember.bl_email}`}>{activeMember.bl_email}</a>
                    </Text>
                    <br />
                    <Text>
                      <a href={`tel:${activeMember.mobile}`}>+47 {activeMember.mobile}</a>
                    </Text>
                  </Col>
                </Row>
              ) : (
                <Text>Kontaktperson for arrangementet er ikke satt enda.</Text>
              )}
            </>
          </StyledCol>
        </StyledRow>
      </Card>
    </>
  );
};

export default EventInfo;
